module.exports = __webpack_public_path__ + "img/24-henry-ward-beecher-quotes.edc3bba9.jpeg";